import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import { DateTime } from 'luxon';

import Content from './ContentBox';
import CalendarPicker from './CalendarPicker';
import ClickOutside from 'app/src/elements/ClickListener';
import { dateRange } from './dateHelpers';

import {
  MarketOption,
  MarketOptionsContainer,
  OptionText
} from './selectElements';

const ShowSoldSelect = ({ showOnlySold, setShowOnlySold }) => {
  const [showOptions, setShowOptions] = useState(false);

  const options = [
    {
      label: 'Show All Assets Listed During the Period',
      showOnlySold: false
    },
    {
       label: 'Only Show Assets Sold During the Period',
      showOnlySold: true
    },
  ];

  const selectedOption = options.find(option => (
    option.showOnlySold === showOnlySold
  ));

  const handleSelect = selected => {
    setShowOnlySold(selected.showOnlySold);
    setShowOptions(false);
  };

  return (
    <View style={{ flex: 1 }}>
      <Pressable onPress={() => setShowOptions(true)}>
        <Content.ValueBox highlight={true}>
          <Content.Value color={'white'}>
            {showOnlySold ? 'Only Show Assets Sold During the Period' : 'Show All Assets Listed During the Period'}
          </Content.Value>
        </Content.ValueBox>
      </Pressable>

      {showOptions && (
        <ClickOutside onClick={() => setShowOptions(false)}>
          <MarketOptionsContainer>
            {options.map(option => {
              const selected =
                option.showOnlySold === showOnlySold

              return (
                <MarketOption
                  key={option.label}
                  onPress={() => handleSelect(option)}
                  selected={selected}
                >
                  <OptionText selected={selected}>{option.label}</OptionText>
                </MarketOption>
              );
            })}

          </MarketOptionsContainer>
        </ClickOutside>
      )}
    </View>
  );
};

export default ShowSoldSelect;
